import { createContext, useContext, useEffect, useState } from "react";
const DataBridgeVersion = '0.18.1';
const DataBridgeContext = createContext(void 0);
const useDataBridge = ()=>{
    const context = useContext(DataBridgeContext);
    if (void 0 === context) throw new Error('useDataBridge must be used within a DataBridgeProvider');
    return context;
};
const useAsyncLoader = (fn, params)=>{
    const [data, setData] = useState(null);
    useEffect(()=>{
        fn(params).then(setData);
    }, [
        fn,
        params
    ]);
    return {
        data,
        isLoading: null === data
    };
};
export { DataBridgeContext, DataBridgeVersion, useAsyncLoader, useDataBridge };
